import { PARTNER_DEMO, type PartnerDemo } from "@/core/data/demoState";

export type PartnerStore = {
	storeId: string;
	storeName: string;
};

export type PartnerProductSummary = {
	productId: string;
	productName: string;
	productCode: string;
	sellingPrice: number;
	productTypeLabel: string;
};

export type PartnerProfile = {
	vendorName: string;
	accountEmail: string;
	registrationNumber: string;
	isAccountActive: boolean;
	isPortalActivated: boolean;
	isPartnerDataSubmitted: boolean;
	isContractApproved: boolean;
	stores: PartnerStore[];
	products: PartnerProductSummary[];
};

export const SAMPLE_ACTIVE_PARTNER: PartnerProfile = {
	vendorName: "Kripik Dea",
	accountEmail: "dea.sarirasa@gmail.com",
	registrationNumber: "REG/250818/204512",
	isAccountActive: true,
	isPortalActivated: true,
	isPartnerDataSubmitted: true,
	isContractApproved: true,
	stores: [
		{ storeId: "store-kokas", storeName: "Kokas" },
		{ storeId: "store-scbd", storeName: "SCBD" },
		{ storeId: "store-lm-nusantara", storeName: "LM Nusantara" },
	],
	products: [
		{
			productId: "product-keripik-singkong-balado",
			productCode: "KD-0001",
			productName: "Keripik Singkong Balado 150 g",
			sellingPrice: 25000,
			productTypeLabel: "Food",
		},
		{
			productId: "product-keripik-pisang-cokelat",
			productCode: "KD-0002",
			productName: "Keripik Pisang Cokelat 120 g",
			sellingPrice: 22000,
			productTypeLabel: "Food",
		},
		{
			productId: "product-sambal-bawang",
			productCode: "KD-0003",
			productName: "Sambal Bawang Botol 150 ml",
			sellingPrice: 30000,
			productTypeLabel: "Food",
		},
	],
};

const SAMPLE_NEW_PARTNER: PartnerProfile = {
	vendorName: "Dapur Rina",
	accountEmail: "dapurrina@gmail.com",
	registrationNumber: "REG/261007/317071",
	isAccountActive: true,
	isPortalActivated: false,
	isPartnerDataSubmitted: false,
	isContractApproved: false,
	stores: [
		{ storeId: "store-kokas", storeName: "Kokas" },
		{ storeId: "store-scbd", storeName: "SCBD" },
	],
	products: [
		{
			productId: "product-keripik-tempe",
			productCode: "DR-0001",
			productName: "Keripik Tempe 100 g",
			sellingPrice: 20000,
			productTypeLabel: "Food",
		},
		{
			productId: "product-es-teh-lemon",
			productCode: "DR-0002",
			productName: "Es Teh Lemon 250 ml",
			sellingPrice: 12000,
			productTypeLabel: "Beverages",
		},
	],
};

export const SAMPLE_PARTNER_BY_DEMO: Record<PartnerDemo, PartnerProfile> = {
	[PARTNER_DEMO.Active]: SAMPLE_ACTIVE_PARTNER,
	[PARTNER_DEMO.NewDataStep]: SAMPLE_NEW_PARTNER,
	[PARTNER_DEMO.NewContractStep]: {
		...SAMPLE_NEW_PARTNER,
		isPartnerDataSubmitted: true,
	},
	[PARTNER_DEMO.NewActivationStep]: {
		...SAMPLE_NEW_PARTNER,
		isPartnerDataSubmitted: true,
		isContractApproved: true,
	},
};
